import preMutate from './pre-mutate';
import preSubmit from './pre-submit';
import mutate from './mutate';
import submit from './submit';
import populate from './populate';
import populatePaymentOption from './populate-payment-option';
import fieldsErrorCodes from './fields-error-codes';
import isModified from './is-modified';
import isFieldDisabled from './is-field-disabled';

import Forms from 'webapp-common-ui/src/reducers/forms';

export const FORM = Forms.newForm({
  preMutate,
  preSubmit,
  mutate,
  submit,
  populate,
  populatePaymentOption,
  fieldsErrorCodes,
  isModified,
  isFieldDisabled,
  defaultState: {
    type: 'EFT',
    firstName: '',
    lastName: '',
    institutionNumber: '', // for EFT type
    branchNumber: '', // for EFT type
    accountNumber: '',
    accountType: 'checking', // checking, savings, corporate
    valid: false,
    errors: [],
    errorsMap: {},
    onChangeValidate: {}, // key/value flags for fields, if flag (key as field) is true (value), validate on each change
  },
});

export {
  preMutate,
  preSubmit,
  mutate,
  submit,
  populate,
};

export default FORM;
